module.exports = __webpack_public_path__ + "static/media/ErrorImg.4bf803c5.jpg";